export const sizeNameMap = {
    "-1": "Unknown Size",
    s: "Small",
    sm: "Small",
    "sm-md": "Small-Medium",
    m: "Medium",
    med: "Medium",
    md: "Medium",
    l: "Large",
    lg: "Large",
    xl: "Extra Large",
    xxl: "Extra Extra Large",
    xxxl: "Extra Extra Extra Large",
};
